import { render, staticRenderFns } from "./PageUserProfile.vue?vue&type=template&id=f1f05b28&scoped=true&"
import script from "./PageUserProfile.vue?vue&type=script&lang=js&"
export * from "./PageUserProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f05b28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1f05b28')) {
      api.createRecord('f1f05b28', component.options)
    } else {
      api.reload('f1f05b28', component.options)
    }
    module.hot.accept("./PageUserProfile.vue?vue&type=template&id=f1f05b28&scoped=true&", function () {
      api.rerender('f1f05b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/userprofile/PageUserProfile.vue"
export default component.exports